import React from "react";
import "./style.css";

const Blog = () => {
  return (
    <div className="blogContainer" id="blog">
      <h2>BLOG</h2>
      <p className="p_blog">
        And guess what? We have super exciting news that will make the
        experience even more magical! We’ve just opened a brand-new branch in
        Bali! Yes, you read that right - the beauty, warmth, and serenity of
        Bali is now home to our newest rhythmic gymnastics center. We believe
        that the enchanting environment of Bali, coupled with the rhythmic
        movements and music of gymnastics, will create an experience for your
        daughters that is as mesmerizing as a fairy-tale.
      </p>
      <img
        className="img_blog"
        src="img_blog_1.png"
        alt="blog_1"
        loading="lazy"
      />
      <p className="p_blog">
        But hold on, it gets even better! Guiding your little ones through their
        graceful movements, we have a coach who is not only an international
        participant but also a prize-winner in global competitions. With such
        expertise and experience, every twirl and jump your daughter takes is a
        step towards becoming a star! We are absolutely thrilled about unfolding
        this chapter in Bali. It’s fresh, it’s exciting, and it promises a world
        of exploration, learning, and fun in the most beautiful setting. We are
        committed to nurturing this new branch with the same love, care, and
        quality that has always defined us. So, if you’re in Bali or planning to
        visit, step into a world where the magic of rhythmic gymnastics comes
        alive amidst the whispering palms and golden sands. Your daughter’s
        journey of strength, grace, and friendship awaits, in a setting as
        enchanting as her beautiful dreams!
      </p>
    </div>
  );
};

export default Blog;
